import styled from 'styled-components';
import { ReportFavoriteButton } from '../../reportsView/shared/ReportFavoriteButton';
import { jsx as _jsx } from "react/jsx-runtime";
const FlushTd = styled.td.withConfig({
  displayName: "FavoriteCell__FlushTd",
  componentId: "sc-1e6sovy-0"
})(["padding-inline:", " !important;"], ({
  theme
}) => theme.space[0]);
const FavoriteCell = ({
  report
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(FlushTd, {
      children: /*#__PURE__*/_jsx(ReportFavoriteButton, {
        report: report
      })
    })
  );
};
export default FavoriteCell;